export default __webpack_public_path__ + "static/media/orderproduct.eaca8530.svg";